/**
 * One `PlaybackStore` per role, kept for the app's lifetime (owner
 * requirement 2026-09-26: "shared app state (one store)") — navigating away
 * from an organism screen and back resumes the same seq/speed/follow-live
 * state instead of resetting the scrubber to live every time.
 */

import { PlaybackStore } from "./PlaybackStore";

const stores = new Map<string, PlaybackStore>();

export function getPlaybackStore(role: string): PlaybackStore {
  let store = stores.get(role);
  if (!store) {
    store = new PlaybackStore();
    stores.set(role, store);
  }
  return store;
}

export function resetPlaybackStoreRegistryForTests(): void {
  stores.clear();
}
